/* eslint-disable require-atomic-updates */
// Disabled is a one-way circuit breaker.
export function createUsageRepository(uid, fetcher = window.fetch.bind(window)) {
  const base = `${(process.env.VUE_APP_API || '').replace(/\/$/, '')}/stockchart/api/usage`;
  let token = '', disabled = false;
  async function request(path, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetcher(base + path, {
        credentials: 'include', cache: 'no-store', ...options, signal: controller.signal
      });
      if (!response.ok) {
        if ([401, 403, 404].includes(response.status)) disabled = true;
        throw new Error('usage_unavailable');
      }
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  return {
    async start() {
      const config = await request('/session');
      if (!config.enabled || Number(config.uid) !== Number(uid) || !config.token) return false;
      token = config.token;
      return true;
    },
    async send(events, keepalive) {
      if (disabled) return;
      const result = await request('/events', {
        method: 'POST', keepalive,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ version: 1, token, events })
      });
      if (result.disabled) disabled = true;
    }
  };
}
